import { Component, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { HeaderComponent } from './components/header/header.component';
import { FooterComponent } from './components/footer/footer.component';
import { SessionLoggerService } from './services/session-logger.service';
import { LogmergeApiService } from './services/logmerge-api.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, HeaderComponent, FooterComponent],
  template: `
    <div class="app-container">
      <app-header></app-header>
      <main class="main-content">
        <router-outlet></router-outlet>
      </main>
      <app-footer></app-footer>
    </div>
  `,
  styles: [`
    .app-container {
      display: flex;
      flex-direction: column;
      min-height: 100vh;
    }
    .main-content {
      flex: 1;
      padding: 30px 20px;
      background-color: var(--chevron-light-gray);
    }
  `]
})
export class AppComponent implements OnInit {
  title = 'LogMerge';

  constructor(
    private sessionLogger: SessionLoggerService,
    private apiService: LogmergeApiService
  ) {}

  ngOnInit(): void {
    this.sessionLogger.info('Application', 'LogMerge application started');
    // Clear any stale backend runtime logs from a previous browser session
    // so the System Logs page starts empty on a fresh page load.
    // Failure is non-fatal (e.g. backend not up yet); the buffer will just
    // populate normally as the next pipeline run emits events.
    this.apiService.resetLogs().subscribe({ error: () => { /* ignore */ } });
  }
}
